export const SERVICE_REASONS = [
  'testdrive',
  'finance',
  'insurance',
  'service',
  'inspection',
  'verified',
  'history',
  'protection',
];

export const isServiceReason = (reason) => SERVICE_REASONS.includes(reason);

export const APPLICATION_LABELS = {
  testdrive: 'Test drive',
  finance: 'Finance',
  insurance: 'Insurance',
  service: 'Service',
  inspection: 'Inspection',
  verified: 'Verified listing',
  history: 'Vehicle history',
  protection: 'Buyer protection',
};

export const DOC_LABELS = {
  cnic_front: 'CNIC front',
  cnic_back: 'CNIC back',
  salary_slip: 'Salary slip / proof of income',
  bank_statement: 'Bank statement',
  income_proof: 'Income proof',
};

export const PRESET_SLOT_TIMES = ['09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00'];

export const formatSlotTime = (value) => {
  const [hourRaw, minuteRaw] = String(value || '').split(':');
  const hour = Number(hourRaw);
  const minute = Number(minuteRaw);
  if (Number.isNaN(hour) || Number.isNaN(minute)) return value || '';
  const suffix = hour >= 12 ? 'PM' : 'AM';
  const hour12 = hour % 12 || 12;
  return `${hour12}:${String(minute).padStart(2, '0')} ${suffix}`;
};

const FILE_ACCEPT = 'image/jpeg,image/png,image/webp,application/pdf';

export const SERVICE_FORMS = {
  finance: {
    title: 'Car financing',
    applicationType: 'finance',
    reason: 'finance',
    meta: 'Apply to finance the selected vehicle.',
    source: 'service_finance',
    docs: [
      { key: 'cnic_front', label: 'CNIC front', required: true, accept: FILE_ACCEPT },
      { key: 'cnic_back', label: 'CNIC back', required: true, accept: FILE_ACCEPT },
      { key: 'salary_slip', label: 'Salary slip / proof of income', required: true, accept: FILE_ACCEPT },
      { key: 'bank_statement', label: 'Bank statement', required: true, accept: FILE_ACCEPT },
    ],
  },
  insurance: {
    title: 'Car insurance',
    applicationType: 'insurance',
    reason: 'insurance',
    meta: 'Request an insurance quote for the selected vehicle.',
    source: 'service_insurance',
    docs: [
      { key: 'cnic_front', label: 'CNIC front', required: true, accept: FILE_ACCEPT },
      { key: 'cnic_back', label: 'CNIC back', required: true, accept: FILE_ACCEPT },
    ],
  },
  service: {
    title: 'Service & maintenance',
    applicationType: 'service',
    reason: 'service',
    meta: 'Book a service appointment for the selected vehicle.',
    source: 'service_maintenance',
    docs: [],
  },
  inspection: {
    title: 'Vehicle inspection',
    applicationType: 'inspection',
    reason: 'inspection',
    meta: 'Book an inspection for the selected vehicle.',
    source: 'service_inspection',
    docs: [],
  },
  verified: {
    title: 'Verified listing',
    applicationType: 'verified',
    reason: 'verified',
    meta: 'Ask us to check this catalog listing.',
    source: 'verified_listings',
    docs: [],
  },
  history: {
    title: 'Vehicle history',
    applicationType: 'history',
    reason: 'history',
    meta: 'Request a history or specification pack for the selected vehicle.',
    source: 'vehicle_history',
    docs: [],
  },
  protection: {
    title: 'Buyer protection',
    applicationType: 'protection',
    reason: 'protection',
    meta: 'The team will contact you about an inspection before you pay.',
    source: 'buyer_protection',
    docs: [],
  },
};

export const authNotice = (reason) => {
  const spec = Object.values(SERVICE_FORMS).find((item) => item.reason === reason);
  if (reason === 'testdrive') {
    return 'Sign in or register to book a test drive for the selected vehicle.';
  }
  if (spec) {
    return `Sign in or register to continue your ${spec.title.toLowerCase()} application.`;
  }
  return '';
};

export const serviceAuthPath = (reason, page) => {
  const params = new URLSearchParams();
  if (isServiceReason(reason)) {
    params.set('reason', reason);
    params.set('next', '/');
  }
  const query = params.toString();
  return query ? `${page}?${query}` : page;
};
